/** Returns array with numbers from given range */
const range = (start: number, end: number): number[] => {
  return Array(end - start + 1)
    .fill(0)
    .map((_, idx: number) => start + idx);
};

export default range;
